/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/no-danger */
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import api from "../../api/api";
import Style from "../../assets/css/main.module.css";
import searchIcon from "../../assets/icons/search.svg";
import { currencyFormat } from "../../library/currency";
import MultiRangeSlider from "../../library/range-slider/MultiRangeSlider";
import
  {
    setCategories,
    setCategory,
    setEntryTickets,
    setPagination,
    setRide,
    setRideTickets,
  } from "../../store/features/branchSlice";
import Loader from "../loader/Loader";
import Ticket from "../ticket/Ticket";

export default function Tickets({ park }) {
  const dispatch = useDispatch();
  const {
    range,
    category,
    ride,
    selectedBranch,
    entryTickets,
    rideTickets,
    pagination,
    categories,
  } = useSelector((state) => state.branchSlice);
  const ref = useRef(null);
  const [loading, setLoading] = useState(false);
  const fetch = async () => {
    setLoading(true);
    let res = await api.categories({ park: park.id });
    if (res.status === 200) {
      dispatch(setCategories(res.data.data));
    }
    res = await api.entry(selectedBranch, { min: range[0], max: range[1] });
    if (res.status === 200) {
      dispatch(setEntryTickets(res.data.data));
    }
    let params;
    if (category) {
      params = { min: range[0], max: range[1], category, ride, limit: 9 };
    } else {
      params = { min: range[0], max: range[1], ride, limit: 9 };
    }

    res = await api.ride(selectedBranch, params);
    if (res.status === 200) {
      dispatch(setRideTickets(res.data.data.data));
      const paginationData = {};
      paginationData.current = res.data.data.current_page;
      paginationData.firstPage = parseInt(
        new URL(res.data.data.first_page_url).searchParams.get("page"),
        10
      );
      paginationData.lastPage = parseInt(
        new URL(res.data.data.last_page_url).searchParams.get("page"),
        10
      );
      paginationData.pages = res.data.data.links;
      dispatch(setPagination(paginationData));
    }
    setLoading(false);
  };
  const paginationHandler = async (url) => {
    if (url) {
      const page = parseInt(new URL(url).searchParams.get("page"), 10);
      let params;
      if (category) {
        params = {
          min: range[0],
          max: range[1],
          category,
          ride,
          limit: 9,
          page,
        };
      } else {
        params = { min: range[0], max: range[1], ride, limit: 9, page };
      }

      const res = await api.ride(selectedBranch, params);
      if (res.status === 200) {
        dispatch(setRideTickets(res.data.data.data));
        const paginationData = {};
        paginationData.current = res.data.data.current_page;
        paginationData.firstPage = parseInt(
          new URL(res.data.data.first_page_url).searchParams.get("page"),
          10
        );
        paginationData.lastPage = parseInt(
          new URL(res.data.data.last_page_url).searchParams.get("page"),
          10
        );
        paginationData.pages = res.data.data.links;
        dispatch(setPagination(paginationData));
      }
    }
  };
  useEffect(() => {
    fetch();
  }, []);
  useEffect(() => {
    if (category || category === "") {
      fetch();
    }
  }, [category]);
  useEffect(() => {
    if (selectedBranch) {
      fetch();
    }
  }, [selectedBranch]);
  useEffect(() => {
    if (range) {
      fetch();
    }
  }, [range]);
  useEffect(() => {
    if (ref.current) {
      ref.current.focus();
    }
  });

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      fetch();
    }
  };

  return (
    <div>
      {loading && (
        <div className="d-flex justify-content-center align-items-center pt-5 w-100">
          <Loader />
        </div>
      )}
      {!loading && (
        <div>
          <div className="d-flex flex-column flex-md-row justify-content-between align-items-center gap-2 mb-4">
            <div className="d-flex w-100 align-items-center p-md-2">
              <div
                className={`${Style.fw_300} ${Style.fs_14} d-none d-md-block`}
              >
                Price Filter
              </div>
              <div
                className={`${Style.bg_white} d-flex flex-column gap-2 w-100 p-2`}
              >
                <div className="d-flex justify-content-between w-100">
                  <div>{currencyFormat(park.min_price)}</div>
                  <div>{currencyFormat(park.max_price)}</div>
                </div>
                <div
                  style={{
                    position: "relative",
                    top: "-25px",
                    width: "100%",
                  }}
                >
                  <MultiRangeSlider
                    min={park.min_price}
                    max={park.max_price}
                    range={range}
                  />
                </div>
              </div>
            </div>
            <div className={`${Style.bg_white} w-100 px-2 position-relative`}>
              <select
                onChange={(e) => dispatch(setCategory(e.target.value))}
                style={{
                  height: "48px",
                  width: "100%",
                  backgroundColor: "#ffffff",
                }}
                value={category}
                className={`${Style.outline_0} ${Style.custom_select} border-0`}
              >
                <option value="">Categories</option>
                {categories.map((item) => (
                  <option key={item.id} value={item.id}>
                    {item.name}
                  </option>
                ))}
              </select>
            </div>
            <div className={`${Style.bg_white} w-100 px-2 position-relative`}>
              <input
                ref={ref}
                type="text"
                placeholder="Search Rides"
                value={ride}
                onChange={(e) => dispatch(setRide(e.target.value))}
                style={{ height: "48px", width: "100%" }}
                className={`${Style.outline_0} border-0`}
                onKeyDown={handleKeyDown}
              />
              <button
                type="button"
                className={`${Style.bg_none} position-absolute border-0`}
                style={{
                  right: "10px",
                  top: "50%",
                  transform: "translateY(-50%)",
                }}
                onClick={() => fetch()}
              >
                <img src={searchIcon} alt="search" />
              </button>
            </div>
          </div>
                    {/* Only show Entry Tickets section if there are tickets */}
                    {entryTickets.length > 0 && (
          <div className="entry-tickets">
            <div
              className={`${Style.border_primary} border-bottom d-flex align-items-center justify-content-between`}
            >
              <div
                className={`${Style.fs_16} ${Style.fw_600} ${Style.text_primary}`}
              >
                Entry Tickets
              </div>
              <div className={`${Style.fs_14} ${Style.fw_300}`}>
                Remember to purchase your entry ticket here
              </div>
            </div>
            <div className="pt-2 d-flex flex-md-row flex-column gap-2 justify-content-md-start justify-content-center flex-wrap align-items-center">
              {entryTickets.map((item) => (
                <div key={item.id}>
                  <Ticket
                    item={{
                      id: item.id,
                      park: item.park_id,
                      name: item.name,
                      price: item.price,
                      offer_price: item.offer_price,
                      photo: [item.park.logo],
                      description: "",
                    }}
                    type="entry"
                  />
                </div>
              ))}
            </div>
          </div>)}
          {/* Only show Ride Tickets section if there are tickets */}
          {rideTickets.length > 0 && (
          <div className="ride-tickets pt-3">
            <div
              className={`${Style.border_primary} border-bottom d-flex align-items-center justify-content-between`}
            >
              <div
                className={`${Style.fs_16} ${Style.fw_600} ${Style.text_primary}`}
              >
                Ride Tickets
              </div>
            </div>
            <div className="pt-2 d-flex flex-md-row flex-column gap-2 justify-content-md-start justify-content-center flex-wrap align-items-center">
              {rideTickets.map((item) => (
                <div key={item.id}>
                  <Ticket
                    item={{
                      id: item.id,
                      park: item.park_id,
                      name: item.name,
                      price: item.price,
                      offer_price: item.offer_price,
                      description: item.rides[0].ride.description,
                      photo: item.rides
                        .filter((rides) => rides.ride.logo)
                        .map((rides) => rides.ride.logo),
                    }}
                    type="ride"
                  />
                </div>
              ))}
              <div
                className="d-flex justify-content-center align-items-center gap-2 pt-5 w-100"
                style={{ paddingBottom: "70px" }}
              >
                {pagination &&
                  rideTickets.length > 0 &&
                  pagination.pages.map((page) => (
                    <button
                      key={Math.random()}
                      type="button"
                      onClick={() => paginationHandler(page.url)}
                      dangerouslySetInnerHTML={{ __html: page.label }}
                      className={`${Style.border_primary} border ${page.active ? `${Style.bg_primary} text-light` : ""}`}
                    />
                  ))}
              </div>
            </div>
          </div>)}
        </div>
      )}
    </div>
  );
}
